export enum CanvasTypeEnum {
  signature = 1,
  rubric = 2
}
